import { getCurrentWindow } from '@tauri-apps/api/window'
import { isTauriRuntime } from '~/lib/platform/runtime'
import { DEBUG_WINDOW_LABEL } from '~/lib/debug/debugBus'

// The debug window always boots the same SPA entry as `main` (see `toggle_debug_window` in
// `lib.rs`), so its very first render resolves to whatever the URL bar/history says — normally
// `/`, i.e. the login page. Pinning it to `/debug` here (a route middleware, evaluated before any
// page component mounts) is what actually keeps it there: doing this redirect only from
// `app.vue`'s `onMounted` let `index.vue`'s own `onMounted` — which runs first, since children
// mount before parents — win the race with its own `checkAuth()` -> `router.push('/dashboard')`
// once that async check resolved, silently pulling the debug window off `/debug` a moment later.
export default defineNuxtRouteMiddleware((to) => {
  if (!isTauriRuntime()) return
  if (getCurrentWindow().label !== DEBUG_WINDOW_LABEL) return
  if (to.path !== '/debug') return navigateTo('/debug', { replace: true })
})
